import { createServiceFactory } from '@/services/factory'
import { createMockAuditService } from './audit.mock'
import { createHttpAuditService } from './audit.http'

export type { AuditService, AuditStatsResult } from './audit.service'

export const getAuditService = createServiceFactory(
  'audit',
  createMockAuditService,
  createHttpAuditService
)
